import type { GlucoseSubEntry } from "@tandemdiabetes/sugarmate-api-react-client"
import { useReadableGlucoseString } from "src/hooks"

interface Props {
  subEntry: GlucoseSubEntry;
}

export function GlucoseMessage(props: Props) {
  const { subEntry } = props

  const readableGlucoseString = useReadableGlucoseString(subEntry.glucose.mg_dl)

  return (
    <>
      {readableGlucoseString}
    </>
  )
}
